module.exports = __webpack_public_path__ + "img/20240814100852026uv2.2cc8a925.jpg";